import { SvgIcon } from 'Components/Base';

export const MENU_KEY = {
  DIVIDER: 'divider',
  MY_PROFILE: 'myProfile',
  PURCHASE_HISTORY: 'purchaseHistory',
  LOGOUT: 'logout',
  HOME: 'home',
  BROWSE: 'browse',
  PROMOTION: 'promotion',
  HOW_TO_USE: 'howToUse',
};

const divider = {
  key: MENU_KEY.DIVIDER,
};

const myProfile = {
  key: MENU_KEY.MY_PROFILE,
  icon: SvgIcon.ICON_LIST.USER_OUTLINED,
  text: 'ข้อมูลส่วนตัว',
};

const purchaseHistory = {
  key: MENU_KEY.PURCHASE_HISTORY,
  icon: SvgIcon.ICON_LIST.REVERSE_CLOCK,
  text: 'ประวัติการสั่งซื้อ',
};

const logout = {
  key: MENU_KEY.LOGOUT,
  icon: SvgIcon.ICON_LIST.LOG_OUT,
  text: 'ออกจากระบบ',
};

const home = {
  key: MENU_KEY.HOME,
  icon: SvgIcon.ICON_LIST.HOME,
  text: 'หน้าแรก',
};

const browse = {
  key: MENU_KEY.BROWSE,
  icon: SvgIcon.ICON_LIST.LIBRARY_BOOK,
  text: 'คอร์สเรียน',
};

const promotion = {
  key: MENU_KEY.PROMOTION,
  icon: SvgIcon.ICON_LIST.TAG,
  text: 'โปรโมชั่น',
};

const howToUse = {
  key: MENU_KEY.HOW_TO_USE,
  icon: SvgIcon.ICON_LIST.INFO_OUTLINED,
  text: 'วิธีการใช้งาน',
};

export const MENU_LIST = {
  [MENU_KEY.MY_PROFILE]: myProfile,
  [MENU_KEY.PURCHASE_HISTORY]: purchaseHistory,
  [MENU_KEY.LOGOUT]: logout,
  [MENU_KEY.HOME]: home,
  [MENU_KEY.BROWSE]: browse,
  [MENU_KEY.PROMOTION]: promotion,
  [MENU_KEY.HOW_TO_USE]: howToUse,
  [MENU_KEY.DIVIDER]: divider,
};
